import { render, staticRenderFns } from "./EmployeeManagement.vue?vue&type=template&id=2805b56a&scoped=true&"
import script from "./EmployeeManagement.vue?vue&type=script&lang=ts&"
export * from "./EmployeeManagement.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeManagement.vue?vue&type=style&index=0&id=2805b56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805b56a",
  null
  
)

export default component.exports